import PropertyThumbnailImage from '@app/components/PropertyThumbnailImage'
import { IProperty } from '@app/models/Property'
import { formatAddressSingleLine } from '@app/utils/formatting'
import * as React from 'react'
import { Link } from 'react-router-dom'

export interface IPropertyResultItemProps {
  item: IProperty
}

export class PropertyResultItem extends React.PureComponent<IPropertyResultItemProps> {
  public render() {
    return (
      <Link
        to={`/properties/property/${this.props.item.id}`}
        className='result-item'
      >
        <div className='align-self-center'>
          <PropertyThumbnailImage property={this.props.item} size={35} />
        </div>
        <div className='flex-grow-1'>
          <div className='font-weight-bold'>{this.props.item.name}</div>
          <div className='small'>
            {formatAddressSingleLine(this.props.item.address)}
          </div>
        </div>
      </Link>
    )
  }
}
